export default {"src":"https://static.jusbr.com/web/docview/_next/static/media/error.203c9db4.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};